import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { DateFormatter } from '@repo/toolkit/date'
import Box from '@repo/ui/box'
import Loader from '@repo/ui/loader'
import { LogSection } from '@repo/ui/log-section'
import Typography from '@repo/ui/typography'
import { useQuery } from '@tanstack/react-query'

import { getCenterLecComments } from '../../../../api/centers/center-lec-comments/get-center-lec-comments'

type Props = {
  id: number
}

const OlPersonalSpaceCenterAdminComments = ({ id }: Props) => {
  const { data: centerAdminComments, isPending } = useQuery({
    queryKey: ['center-admin-comments'],
    queryFn: () => getCenterLecComments({ centerId: id, filter: { sharedToOl: true } })
  })

  if (isPending) return <Loader center />

  if (centerAdminComments?.total === 0) return null

  return (
    <Box className="bg-white-hover rounded-lg border border-grey-light ">
      <Typography variant="text" color={tailwindColors.primary.DEFAULT}>
        LEC comments
      </Typography>
      <div className="h-4" />
      <LogSection
        logItemClassName="bg-white border border-grey-light"
        data={
          centerAdminComments?.data?.map((comment) => ({
            comment: comment.comment,
            updatedAt: new Date(comment.updatedAt)
          })) || []
        }
        dateFormatter={(date) => DateFormatter.ddMMyyyyHHmm(date)}
      />
    </Box>
  )
}

export default OlPersonalSpaceCenterAdminComments
